import { FormAutoGenerated } from '@visualfabriq/vf-ui-kit';
import {
  FieldItem,
  FormLayoutRow,
} from '@visualfabriq/vf-ui-kit/dist/components/molecules/form/form-auto-generated/types';
import { useMemo } from 'react';

import { DataProcessingConfigInput, ECRImage } from 'src/api-new/bifrost';
import { requiredField } from 'src/components/UIKitTweaks';
import * as DataProcessingStep from 'src/dto/PipelineStep/DataProcessingStep';

type Props = {
  configuration: DataProcessingConfigInput;
  onChange: (configuration: DataProcessingConfigInput) => void;
  onValidChange: (isValid: boolean) => void;
};
export function TemplateStepConfigurationForm(props: Props) {
  const { configuration, onChange, onValidChange } = props;

  const initData = useMemo(() => {
    const configurationFormFields: Pick<
      DataProcessingConfigInput,
      'image' | 'function_link' | 'job_timeout' | 'job_size' | 'can_be_stopped'
    > = {
      job_timeout: configuration.job_timeout,
      image: configuration.image,
      function_link: configuration.function_link,
      job_size: configuration.job_size,
      can_be_stopped: configuration.can_be_stopped,
    };

    return configurationFormFields;
  }, []);

  const handleConfigurationFormFieldsChange = (
    event: Pick<DataProcessingConfigInput, 'image' | 'function_link' | 'job_timeout' | 'can_be_stopped'>,
  ) => {
    onChange({
      ...configuration,
      ...event,
    });
  };

  return (
    <FormAutoGenerated
      initData={initData}
      onFormValidChange={onValidChange}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onDataChange={handleConfigurationFormFieldsChange as any}
      fields={TEMPLATE_FIELDS}
      layout={TEMPLATES_FIELDS_LAYOUT}
    />
  );
}

const TEMPLATE_FIELDS: FieldItem[] = [
  {
    ...requiredField,
    field_id: 'image',
    field_desc: 'Image',
    data_type: 'select',
    value_list: Object.values(ECRImage).map((label) => ({
      value_id: label,
      id: label,
      value_name: label,
      name: label,
    })),
  },
  {
    ...requiredField,
    field_id: 'job_size',
    field_desc: 'Job Size',
    data_type: 'select',
    value_list: Array.from(Object.values(DataProcessingStep.JobSize)).map((jobSize) => ({
      value_id: jobSize,
      id: jobSize,
      value_name: jobSize,
      //@ts-expect-error AUTOMATICALLY GENERATED PLS FIX
      name: DataProcessingStep.JobSize[jobSize],
    })),
  },
  {
    ...requiredField,
    field_id: 'function_link',
    field_desc: 'Script',
    data_type: 'text',
  },
  {
    ...requiredField,
    field_id: 'job_timeout',
    field_desc: 'Timeout',
    data_type: 'number',
  },
  {
    ...requiredField,
    field_id: 'can_be_stopped',
    field_desc: 'Can be stopped?',
    data_type: 'boolean',
  },
];
const TEMPLATES_FIELDS_LAYOUT: FormLayoutRow[] = TEMPLATE_FIELDS.map((field) => [
  { field: field.field_id, cols: [4, 6, 12] },
]);
